export const GET_PARTNERS = 'src/pages/partners/GET_PARTNERS';
export const GET_PARTNERS_SUCCESS = 'src/pages/partners/GET_PARTNERS__SUCCESS';
export const GET_PARTNERS_FAILED = 'src/pages/partners/GET_PARTNERS__FAILED';

export const GET_PARTNER_WITH_ID = 'src/pages/partners/GET_PARTNER_WITH_ID';
export const GET_PARTNER_WITH_ID_SUCCESS =
  'src/pages/partners/GET_PARTNER_WITH_ID_SUCCESS';
export const GET_PARTNER_WITH_ID_FAILED =
  'src/pages/partners/GET_PARTNER_WITH_ID_FAILED';

export const UPDATE_PARTNER = 'src/pages/partners/UPDATE_PARTNER';
export const UPDATE_PARTNER_SUCCESS =
  'src/pages/partners/UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_FAILED = 'src/pages/partners/UPDATE_PARTNER_FAILED';

export const UPDATE_PARTNER_ADMIN = 'src/pages/partners/UPDATE_PARTNER_ADMIN';
export const UPDATE_PARTNER_ADMIN_SUCCESS =
  'src/pages/partners/UPDATE_PARTNER_ADMIN_SUCCESS';
export const UPDATE_PARTNER_ADMIN_FAILED =
  'src/pages/partners/UPDATE_PARTNER_ADMIN_FAILED';

export const UPDATE_PARTNER_STATUS = 'src/pages/partners/UPDATE_PARTNER_STATUS';
export const UPDATE_PARTNER_STATUS_SUCCESS =
  'src/pages/partners/UPDATE_PARTNER_STATUS_SUCCESS';
export const UPDATE_PARTNER_STATUS_FAILED =
  'src/pages/partners/UPDATE_PARTNER_STATUS_FAILED';

export const CREATE_PARTNER = 'src/pages/partners/CREATE_PARTNER';
export const CREATE_PARTNER_SUCCESS =
  'src/pages/partners/CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_FAILED = 'src/pages/partners/CREATE_PARTNER_FAILED';

export const GET_USERS_BY_PARTNERID =
  'src/pages/partners/GET_USERS_BY_PARTNERID';
export const GET_USERS_BY_PARTNERID_SUCCESS =
  'src/pages/partners/GET_USERS_BY_PARTNERID_SUCCESS';
export const GET_USERS_BY_PARTNERID_FAILED =
  'src/pages/partners/GET_USERS_BY_PARTNERID_FAILED';

export const GET_USERS_BE_ADMIN_PARTNER =
  'src/pages/partners/GET_USERS_BE_ADMIN_PARTNER';
export const GET_USERS_BE_ADMIN_PARTNER_SUCCESS =
  'src/pages/partners/GET_USERS_BE_ADMIN_PARTNER_SUCCESS';
export const GET_USERS_BE_ADMIN_PARTNER_FAILED =
  'src/pages/partners/GET_USERS_BE_ADMIN_PARTNER_FAILED';

export const GET_PARTNERS_INVONTORY =
  'src/pages/partners/GET_PARTNERS_INVONTORY';
export const GET_PARTNERS_INVONTORY_SUCCESS =
  'src/pages/partners/GET_PARTNERS_INVONTORY_SUCCESS';
export const GET_PARTNERS_INVONTORY_FAILED =
  'src/pages/partners/GET_PARTNERS_INVONTORY_FAILED';

export const GET_PARTNER_CATEGORIES =
  'src/pages/partners/GET_PARTNER_CATEGORIES';
export const GET_PARTNER_CATEGORIES_SUCCESS =
  'src/pages/partners/GET_PARTNER_CATEGORIES_SUCCESS';
export const GET_PARTNER_CATEGORIES_FAILED =
  'src/pages/partners/GET_PARTNER_CATEGORIES_FAILED';
